(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.component.blog-list').each(function () {
      $('#blog-list li', $(this)).each(function () {
        $('.news-date', $(this)).insertBefore($('.news-text', $(this)));
      });
    });
  });
})(jQuery);